import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getPopImapConfiguration } from 'owa-popimap-configuration';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    popImapConfigurationState: function () { return getPopImapConfiguration(); },
})(function isPopOptionDirty(state) {
    if (!state.popImapConfigurationState) {
        return false;
    }
    var popEnabled = getFallbackValueIfNull(state.optionState.popEnabled, state.popImapConfigurationState.popEnabled);
    var popMessageDeleteEnabled = getFallbackValueIfNull(state.optionState.popMessageDeleteEnabled, state.popImapConfigurationState.popMessageDeleteEnabled);
    return (popEnabled !== state.popImapConfigurationState.popEnabled ||
        popMessageDeleteEnabled !== state.popImapConfigurationState.popMessageDeleteEnabled);
});
//# sourceMappingURL=isPopOptionDirty.js.map